import React from 'react';

export const CanopiLogo = ({ size = 40, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Outer ring */}
      <ellipse cx="100" cy="100" rx="88" ry="90" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.6" />
      {/* Second ring */}
      <path d="M100 20 C145 22, 178 55, 180 100 C182 145, 148 180, 100 182 C55 183, 22 150, 20 100 C18 55, 52 22, 100 20Z" stroke="currentColor" strokeWidth="1.8" fill="none" opacity="0.5">
      </path>
      {/* Third ring - more organic */}
      <path d="M100 35 C138 33, 165 60, 168 100 C170 138, 142 168, 100 170 C62 171, 35 142, 33 100 C31 62, 58 35, 100 35Z" stroke="currentColor" strokeWidth="1.8" fill="none" opacity="0.6" />
      {/* Fourth ring */}
      <path d="M100 50 C132 48, 152 68, 154 100 C156 130, 135 155, 100 156 C68 157, 48 135, 47 100 C46 68, 66 50, 100 50Z" stroke="currentColor" strokeWidth="1.8" fill="none" opacity="0.7" />
      {/* Fifth ring - inner */}
      <path d="M100 65 C124 63, 138 78, 140 100 C142 122, 126 140, 100 141 C78 142, 62 126, 61 100 C60 78, 74 65, 100 65Z" stroke="currentColor" strokeWidth="1.8" fill="none" opacity="0.8" />
      {/* Inner core ring */}
      <path d="M100 80 C114 79, 122 88, 123 100 C124 112, 115 123, 100 124 C88 124, 79 115, 78 100 C77 88, 86 80, 100 80Z" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.9" />
      {/* Center triangular seed shape */}
      <path d="M100 88 C107 88, 112 93, 112 100 C112 107, 107 112, 100 112 C93 112, 88 107, 88 100 C88 93, 93 88, 100 88Z" stroke="currentColor" strokeWidth="2" fill="none" />
      
      {/* Network dots - subtle connection points */}
      <circle cx="100" cy="14" r="2" fill="currentColor" opacity="0.5" />
      <circle cx="185" cy="100" r="2" fill="currentColor" opacity="0.5" />
      <circle cx="100" cy="186" r="2" fill="currentColor" opacity="0.5" />
      <circle cx="15" cy="100" r="2" fill="currentColor" opacity="0.5" />
      <circle cx="155" cy="40" r="1.5" fill="currentColor" opacity="0.4" />
      <circle cx="160" cy="155" r="1.5" fill="currentColor" opacity="0.4" />
      <circle cx="40" cy="160" r="1.5" fill="currentColor" opacity="0.4" />
      <circle cx="38" cy="42" r="1.5" fill="currentColor" opacity="0.4" />
      <circle cx="130" cy="55" r="1.5" fill="currentColor" opacity="0.35" />
      <circle cx="145" cy="130" r="1.5" fill="currentColor" opacity="0.35" />
      <circle cx="55" cy="140" r="1.5" fill="currentColor" opacity="0.35" />
      <circle cx="58" cy="60" r="1.5" fill="currentColor" opacity="0.35" />
    </svg>
  );
};

export const CanopiWordmark = ({ className = '' }) => (
  <span className={`font-light tracking-[0.3em] uppercase text-white ${className}`} style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
    CANOPI<span className="text-white/50 tracking-[0.2em] ml-1">AI</span>
  </span>
);
